import './styles';
import {useMemo} from 'react';

import {Box, Chip, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {
  AppButton,
  AppButtonVariant,
  ButtonContainer,
} from '@/app/shared-components';
import ChangeTextWithColorAndImage from '@/app/shared-components/ColorAndImageText/ColorAndImageText';
import GeoMap from '@/app/shared-components/GeoMap/GeoMap';
import {COLORS} from '@/styles/colors';

import {useViewModelProvider, ViewModelProvider} from './ViewModelContext';

const RequestPhysicalCardContent = () => {
  const {
    kidData,
    shippingAddress,
    handleConfirmShippingAddress,
    handleTypeForm,
  } = useViewModelProvider();

  const {t} = useTranslation();

  const addressLine1 = useMemo(
    () => shippingAddress?.line?.split(',')?.[0],
    [shippingAddress?.line],
  );

  const title = useMemo(
    () => t('request_card.title', {name: kidData?.firstName}),
    [kidData?.firstName, t],
  );

  const country = useMemo(
    () =>
      shippingAddress?.country?.toUpperCase() === 'US'
        ? t('request_card.us')
        : shippingAddress?.country,
    [shippingAddress?.country, t],
  );

  return (
    <Box className="request-physical-card-page-container">
      <section className="request-physical-card-title-container">
        <ChangeTextWithColorAndImage
          text={title}
          textStyle={{
            color: COLORS.ON_SURFACE,
            fontFamily: 'Poppins',
            fontSize: 22,
            fontStyle: 'normal',
            fontWeight: 600,
            letterSpacing: -0.22,
            textAlign: 'left',
          }}
        />

        <Typography className="request-physical-card-address">
          {t('request_card.estimate_delivery')}
        </Typography>
      </section>

      <Box className="request-physical-card-body-container">
        <GeoMap
          line1={addressLine1}
          city={shippingAddress?.city}
          country={shippingAddress?.country}
          state={shippingAddress?.state}
          postal_code={shippingAddress?.zip_code}
        />
        <Box className="request-physical-card-body-content">
          <Box>
            <Typography className="request-physical-card-address address-line">
              {addressLine1}
            </Typography>
            {shippingAddress?.additional_address && (
              <Typography className="request-physical-card-address address-line">
                {shippingAddress.additional_address}
              </Typography>
            )}
            <Typography className="request-physical-card-address">
              {shippingAddress?.city}, {shippingAddress?.state}{' '}
              {shippingAddress?.zip_code}
            </Typography>
            <Typography className="request-physical-card-address">
              {country}
            </Typography>
          </Box>
          <Chip
            label={t('request_card.free_delivery')}
            size="small"
            className="delivery-chip"
          />
        </Box>
      </Box>

      <Box className="request-physical-card-footer-container">
        <Typography className="request-physical-card-footer-text">
          {t('request_card.wrong_address')}{' '}
          <span
            id="request-physical-card-request-change-link"
            className="request-physical-card-footer-link"
            onClick={handleTypeForm}>
            {t('request_card.request_change')}
          </span>
        </Typography>

        <Typography className="request-physical-card-disclaimer">
          {t('request_card.match_address')}
        </Typography>
      </Box>
      <ButtonContainer sticky>
        <Box className="request-physical-card-button-container">
          <AppButton
            id="request-physical-card-confirm-shipping-address-button"
            label={t('request_card.button')}
            onClick={handleConfirmShippingAddress}
            variant={AppButtonVariant.onPrimary}
          />
        </Box>
      </ButtonContainer>
    </Box>
  );
};

const RequestPhysicalCardPage = () => (
  <ViewModelProvider>
    <RequestPhysicalCardContent />
  </ViewModelProvider>
);

export default RequestPhysicalCardPage;
